<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button
        (click)="createDraft()"
        *ngIf="this.state.isBigScreen && this.reportId == null"
        >Als @if(reports.length > 1){Entwürfe}@else{Entwurf}
        speichern</ion-button
      >
      <ion-button
        (click)="createDraft()"
        *ngIf="
          this.state.isBigScreen &&
          this.reportId != null &&
          this.reports[0].isDraft
        "
        >Entwurf aktualisieren</ion-button
      >
      <ion-button
        [disabled]="errorList.length > 0"
        (click)="sendReport()"
        *ngIf="this.reportId == null || this.reports[0].isDraft"
        >{{ reportTypeLabel }}@if(reports.length > 1){e} absenden</ion-button
      >
      <ion-button
        [disabled]="errorList.length > 0"
        (click)="sendReport()"
        *ngIf="this.reportId != null && !this.reports[0].isDraft"
        >{{ reportTypeLabel }} aktualisieren</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="background-container">
    @if(!reportId){
    <div class="segment-container">
      <ion-segment
        mode="ios"
        [(ngModel)]="reportType"
        (ionChange)="changeReportTypeLabel()"
      >
        <ion-segment-button [value]="ConstructionDayReportType.$0">
          <ion-label>Bautagesbericht</ion-label>
          <ion-icon style="font-size: 24px" name="clipboard-outline"></ion-icon>
        </ion-segment-button>
        <ion-segment-button [value]="ConstructionDayReportType.$1">
          <ion-label>Fahrtenbericht</ion-label>
          <ion-icon
            style="font-size: 24px"
            name="speedometer-outline"
          ></ion-icon>
        </ion-segment-button>
        <ion-segment-button [value]="ConstructionDayReportType.$2">
          <ion-label>Arbeitszeitbericht</ion-label>
          <ion-icon style="font-size: 24px" name="time-outline"></ion-icon>
        </ion-segment-button>
      </ion-segment>
    </div>
    } @for (report of reports;track report; let reportIndex = $index) {
    <div class="box-container">
      @if(!reportId){
      <div class="box-container-caption">
        <div>{{ reportTypeLabel }} {{ reportIndex + 1 }}</div>
        @if(reports?.length > 1){
        <ion-icon
          style="margin-right: 14px; font-size: 26px; cursor: pointer"
          name="trash-outline"
          (click)="removeReport(reportIndex)"
        ></ion-icon>
        }
      </div>
      }

      <div class="select-form wide" style="margin-top: 15px">
        <lib-date-time-picker
          [type]="'date'"
          [inputDateZulu]="report.date"
          (selectedDateChanged)="dateChanged($event, report)"
        ></lib-date-time-picker>
      </div>
      @if(weekendOrPublicHolidaySelected(report.date)){
      <div class="select-form no-workday-warning">
        <div class="centered">
          <ion-icon
            size="small"
            name="information-circle-outline"
            style="margin-right: 4px"
          ></ion-icon>
          Info: Wochenende ausgewählt
        </div>
      </div>
      }
      <div class="select-form">
        <lib-construction-site-picker
          [conSites]="this.state.conSites$"
          [multiple]="false"
          (selectedConSiteChanged)="conSiteChange($event, report)"
          [preselectedConSite]="report.constructionSite"
        ></lib-construction-site-picker>
      </div>
      <div class="select-form">
        <lib-user-picker
          [preselectedUsers]="this.state.userName"
          [users]="this.state.users$"
          [isResponsible]="reportType != ConstructionDayReportType.$1"
          [isDriver]="reportType == ConstructionDayReportType.$1"
          [showAllEntry]="false"
          (selectedUserChanged)="responsibleWorkerChange($event, report)"
        ></lib-user-picker>
      </div>

      <div class="box-header">
        @if(reportType == ConstructionDayReportType.$1){ Fahrtzeiten }@else {
        Arbeitszeiten Baustelle }
      </div>

      <div class="working-hours">
        @if(reportType != ConstructionDayReportType.$0){
        <div
          class="other-bookings"
          *ngIf="
            userHasOtherConSiteWorkingTimes(report.responsibleWorker, report)
          "
        >
          <div>Bereits gebucht:</div>
          <div
            *ngFor="
              let entry of getOtherConSiteWorkingTimes(
                report.responsibleWorker,
                report
              )
            "
          >
            {{ entry }}
          </div>
        </div>
        <div
          class="suggestions"
          *ngIf="userHasWorkingTimes(report.responsibleWorker, report)"
        >
          <div
            class="wide"
            *ngFor="
              let entry of getThisConSiteWorkingTimes(
                report.responsibleWorker,
                report
              )
            "
          >
            <div>{{ getBeautifiedString(entry) }}</div>
            <ion-button
              (click)="takeUserHours(report.responsibleWorker, entry, report)"
              >Übernehmen</ion-button
            >
          </div>
        </div>
        }
        <div class="custom-table">
          <div class="row header">
            <div class="col">Startzeit</div>
            <div class="col">Endzeit</div>
            <div class="col grow">
              Summe: {{ this.tools.calculateHours(report.workingTimes) }}
            </div>
          </div>
          @for (entry of report.workingTimes;track entry; let i = $index) {
          <div class="row">
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [inputDateZulu]="entry.start"
                (selectedDateChanged)="
                  timeEntryStartChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [hourDelay]="1"
                [inputDateZulu]="entry.end"
                (selectedDateChanged)="
                  timeEntryEndChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col grow">
              <ion-icon
                style="font-size: 22px; margin-top: 5px; cursor: pointer"
                (click)="removeTimeEntry(report.workingTimes, i)"
                name="trash-outline"
              ></ion-icon>
            </div>
          </div>
          }
        </div>
        <div style="margin: 4px 0 0 6px">
          <ion-button
            size="small"
            fill="outline"
            (click)="addTimeEntry(report.workingTimes, report)"
            ><ion-icon name="add-outline" style="font-size: 22px"></ion-icon
            >Zeit hinzufügen</ion-button
          >
        </div>
      </div>
      @if(reportType == ConstructionDayReportType.$0){
      <div class="select-form">
        <lib-user-picker
          [users]="this.state.users$"
          [multiple]="true"
          (selectedUserChanged)="workerChange($event, report)"
          [preselectedUsers]="report.workers"
        ></lib-user-picker>
      </div>
      @if(report.workers?.length > 0){ @for(worker of report.workers;track
      worker){
      <div class="box-header">
        Arbeitszeit {{ this.state.getUserDisplayNameAsync(worker) | async }}
      </div>
      <div class="working-hours">
        <div
          class="other-bookings"
          *ngIf="userHasOtherConSiteWorkingTimes(worker, report)"
        >
          <div>Bereits gebucht:</div>
          <div
            *ngFor="let entry of getOtherConSiteWorkingTimes(worker, report)"
          >
            {{ entry }}
          </div>
        </div>
        <div class="suggestions" *ngIf="userHasWorkingTimes(worker, report)">
          <div
            class="wide"
            *ngFor="let entry of getThisConSiteWorkingTimes(worker, report)"
          >
            <div>{{ getBeautifiedString(entry) }}</div>
            <ion-button (click)="takeUserHours(worker, entry, report)"
              >Übernehmen</ion-button
            >
          </div>
        </div>

        <div class="custom-table">
          <div class="row header">
            <div class="col">Startzeit</div>
            <div class="col">Endzeit</div>
            <div class="col grow">
              Summe:
              {{ this.tools.calculateHours(report.workerTimeEntries[worker]) }}
            </div>
          </div>
          @for (entry of report.workerTimeEntries[worker];track entry;let i =
          $index) {
          <div class="row">
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [inputDateZulu]="entry.start"
                (selectedDateChanged)="
                  timeEntryStartChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [inputDateZulu]="entry.end"
                (selectedDateChanged)="
                  timeEntryEndChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col grow">
              <ion-icon
                style="font-size: 22px; margin-top: 5px"
                (click)="removeTimeEntry(report.workerTimeEntries[worker], i)"
                name="trash-outline"
              ></ion-icon>
            </div>
          </div>
          }
        </div>
        <div style="margin: 4px 0 0 6px">
          <ion-button
            size="small"
            fill="outline"
            (click)="addTimeEntry(report.workerTimeEntries[worker], report)"
            ><ion-icon name="add-outline" style="font-size: 22px"></ion-icon
            >Zeit hinzufügen</ion-button
          >
          <div style="margin: 2px 0 0 2px">
            @if(report.workerTimeEntries[worker].length == 0){
            <div>
              Fehler: Zeiten dürfen nicht leer sein. Bitte Zeiten hinzufügen
              oder Mitarbeiter entfernen
            </div>
            }
            @if(this.tools.timeEntriesInvalid(report.workerTimeEntries[worker])){
            <div>Fehler: Endzeit liegt vor Startzeit</div>
            } @if(this.timeCollisionDetected(worker, report)){
            <div>
              Fehler: Arbeitszeit überschneidet sich mit bereits gebuchten
              Arbeitszeiten
            </div>
            }
          </div>
        </div>
      </div>
      } }
      <div class="select-row">
        <ion-select
          label="Witterung"
          label-placement="floating"
          mode="md"
          fill="outline"
          interface="popover"
          multiple
          [(ngModel)]="report.weather"
        >
          <ion-select-option
            *ngFor="let weatherOption of this.weatherOptions"
            [value]="weatherOption"
            >{{ weatherOption }}</ion-select-option
          >
        </ion-select>
        <ion-input
          labelPlacement="floating"
          fill="outline"
          mode="md"
          label="Grad Celsius"
          type="number"
          [(ngModel)]="report.temperatureInCelsius"
          pattern="-?[0-9]+"
        >
        </ion-input>
      </div>

      <div class="select-row">
        <ion-input
          labelPlacement="floating"
          fill="outline"
          mode="md"
          label="Stromverbrauch (kWH)"
          type="number"
          [(ngModel)]="report.electricityUsedInKWH"
        >
        </ion-input>
        <ion-input
          labelPlacement="floating"
          fill="outline"
          type="number"
          mode="md"
          label="Wasserverbrauch (m³)"
          [(ngModel)]="report.waterUsedInCubicMeters"
        ></ion-input>
      </div>

      <div class="select-form">
        <ion-checkbox
          stlye="margin-bottom:10px"
          [(ngModel)]="report.securityCheck"
          (ionChange)="checkForInvalidFields()"
          >Sicherheitscheck</ion-checkbox
        >
      </div>
      }
      <div class="select-form">
        <ion-textarea
          label="Leistungsergebnisse"
          labelPlacement="floating"
          fill="outline"
          [(ngModel)]="report.report"
          mode="md"
          placeholder="Text hinzufügen.."
          [autoGrow]="true"
          (ionInput)="checkForInvalidFields()"
        ></ion-textarea>
      </div>
      @if(reportType == ConstructionDayReportType.$0){
      <div class="select-form">
        <ion-textarea
          label="Rapport / Taglohnarbeiten"
          labelPlacement="floating"
          mode="md"
          fill="outline"
          [(ngModel)]="report.rapport"
          placeholder="Text hinzufügen.."
          [autoGrow]="true"
        ></ion-textarea>
      </div>

      <div class="select-form">
        <ion-textarea
          label="Behinderungen / Erschwernisse"
          labelPlacement="floating"
          mode="md"
          fill="outline"
          [(ngModel)]="report.difficulties"
          placeholder="Text hinzufügen.."
          [autoGrow]="true"
        ></ion-textarea>
      </div>

      <div class="select-form">
        <ion-textarea
          label="Besondere Vorkommnisse"
          labelPlacement="floating"
          mode="md"
          fill="outline"
          [(ngModel)]="report.specialIncidents"
          placeholder="Text hinzufügen.."
          [autoGrow]="true"
        ></ion-textarea>
      </div>
      <!--div class="box-header">Maschinennutzung</div>
      <div class="working-hours">
        <lib-machine-picker
          [preselectedItem]="preselectedMachines"
          [items]="state.machines$"
          [multiple]="true"
          (selectedItemChanged)="selectedMachinesChanged($event, report)"
        ></lib-machine-picker>

        @for(machine of report.machineUsages; track machine;){

        <h5>{{ state.getMachineNameAsync(machine.id) | async }}</h5>
        <div class="wide" style="margin-bottom: 10px">
          <ion-input
            labelPlacement="floating"
            fill="outline"
            mode="md"
            label="Stunden"
            type="number"
            [(ngModel)]="machine.usageInHours"
            pattern="^[0-9]+([,.][0-9]+)?$"
            style="margin-right: 5px"
          >
          </ion-input>
          <ion-input
            labelPlacement="floating"
            fill="outline"
            mode="md"
            label="Tage"
            type="number"
            [(ngModel)]="machine.usageInDays"
            pattern="^[0-9]+([,.][0-9]+)?$"
          >
          </ion-input>
        </div>
        <ion-textarea
          label="Beschreibung"
          labelPlacement="floating"
          mode="md"
          fill="outline"
          [(ngModel)]="machine.description"
          placeholder="Text hinzufügen.."
          [autoGrow]="true"
        ></ion-textarea>

        }
      </div-->
      } @if(uploadRequests[reportIndex] == null ||
      uploadRequests[reportIndex].length == 0){
      <div class="select-form">
        <ion-button (click)="openFileInput(reportIndex)"
          ><ion-icon
            name="cloud-upload-outline"
            slot="start"
            class="white"
          ></ion-icon
          >Dokumente hinzufügen</ion-button
        >
      </div>
      }

      <lib-upload
        (filesChanged)="setUploadFiles($event, reportIndex)"
        (uniqueIdChanged)="setUniqueId($event, reportIndex)"
        [constructionDayReportId]="reportId"
        [displayName]="'diesem Bericht'"
      ></lib-upload>
      @if(attachedNodeItems.length > 0 && nodeItemsToDelete.length !=
      attachedNodeItems.length){

      <div class="select-form">
        <div>Dokumente</div>
        @for(doc of attachedNodeItems; track doc.id){
        @if(!nodeItemsToDelete.includes(doc.id)){
        <div class="wide document">
          <div class="centered">
            <ion-icon
              [name]="state.getIcon(doc)"
              style="margin-right: 5px"
            ></ion-icon>
            <div>{{ doc.displayName }}</div>
          </div>
          <ion-icon
            name="trash-outline"
            class="red"
            (click)="deleteNodeItem(doc.id)"
          ></ion-icon>
        </div>
        } }
      </div>
      }
    </div>

    } @if(errorList.length > 0){
    <div class="error-container">
      @for (error of errorList;track $index) {
      <div class="error-list danger">
        {{ error }}
      </div>
      }
    </div>
    }
    <div class="bottom-buttons">
      @if(this.reportId == null){
      <ion-button (click)="addNewReport()">
        <ion-icon name="add-outline" slot="start"></ion-icon>
        Weiteren {{ reportTypeLabel }} hinzufügen</ion-button
      >
      <ion-button fill="outline" (click)="createDraft()"
        ><ion-icon slot="start" name="document-text-outline"></ion-icon>Als
        @if(reports.length > 1){Entwürfe}@else{Entwurf} speichern</ion-button
      >
      }
      <ion-button
        fill="outline"
        (click)="createDraft()"
        *ngIf="this.reportId != null && this.reports[0].isDraft"
        >Entwurf aktualisieren</ion-button
      >
      <ion-button
        color="success"
        [disabled]="errorList.length > 0"
        (click)="sendReport()"
        *ngIf="this.reportId == null || this.reports[0].isDraft"
        ><ion-icon slot="start" name="paper-plane-outline"></ion-icon
        >{{ reportTypeLabel }}@if(reports.length > 1){e} absenden</ion-button
      >
      <ion-button
        [disabled]="errorList.length > 0"
        (click)="sendReport()"
        *ngIf="this.reportId != null && !this.reports[0].isDraft"
        >{{ reportTypeLabel }} aktualisieren</ion-button
      >
    </div>
  </div>
</ion-content>
